<template>
    <main>
        <div class="mt-5" v-if="loading">
            <div class="mt-5">
                <br />
                <br />
                <br />
                <loader />
            </div>
        </div>
        <div v-else class="errorClass"></div>
    </main>
</template>
<script>

    import loader from "@/views/shared/loading/Loading.vue";
    export default {
        name: "authd-ashboard",
        components: {
            loader,
        },
        data() {
            return {
                loading: true,
            }
        },
        mounted() {
            this.samlLogin();
        },
        methods: {
            samlLogin() {
                const errorMessages = document.getElementsByClassName('error-message');
                while (errorMessages.length > 0) {
                    errorMessages[0].remove();
                }
                const self = this;
                self.errormsg = false;
                 window.currentAction = 'list';
                axios.get('api/auth/saml-login').then(function (response) {
                    if (response.data.two_fa_status == 'Yes') {
                        self.$router.push('/auth/verify-otp');
                    } else {
                        self.$store.commit('login', response.data);
                        self.$router.push('/modules/home');
                    }
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                    let err = localStorage.getItem('Errors');
                    let err_msg = (JSON.parse(err));
                    let err_msg2 = err_msg && err_msg.errors ? err_msg.errors : {};
                    Object.keys(err_msg2 || {}).forEach((key) => {
                        let errorval = err_msg2[key];
                        const input = document.getElementsByClassName('errorClass');
                        const errorDiv = document.createElement('span');
                        errorDiv.className = 'error d-block mt-2';
                        errorDiv.textContent = errorval;
                        input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                    });
                    localStorage.removeItem('Errors');
                    self.$router.push('/auth/login');
                });
            }
        }
    }
</script>